import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import MenuItem from "./item";
import MenuBehavior from "../../../behaviors/menu";
import NavigationBehavior from "../../../behaviors/navigation";
import { routeFromHash, hashFromRoute } from "../../../utils/index";
import "../../../../../sass/side-menu.scss";

const channel = Radio.channel("global");

const SELECTED_NODE_CLASS_NAME = "selected";
const DEFAULTS = {
  childView: MenuItem,
};
const CATEGORY = "home";

class View extends Marionette.CollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  tagName() {
    return "ul";
  }

  className() {
    return "nav in sidebar-nav navbar-collapse";
  }

  behaviors() {
    return [
      { behaviorClass: MenuBehavior },
      {
        behaviorClass: NavigationBehavior,
        category: CATEGORY,
        route: this._getActiveRoute(),
      },
    ];
  }

  initialize() {
    // setup listeners
    this.listenTo(channel, CATEGORY, this._handleRouteChange);
  }

  _getActiveRoute() {
    // extract target location, if set.
    // exists when a user reloads the app while at an active route.
    this.targetHash = RVC.targetLocation.hash || null;
    if ("#/" === this.targetHash) {
      // ignore it when it is set to the default route
      this.targetHash = "";
    }

    // get user's preferred home route
    this.userHomeRoute = channel.request("auth:default-route");

    let route = null;
    // is there a target location?
    // i.e.user refreshed the browser while looking at a report
    if (!_.isEmpty(this.targetHash)) {
      // convert hash to route
      route = routeFromHash(this.targetHash);
    } else if (this.userHomeRoute) {
      // route saved in localstorage
      route = this.userHomeRoute;
    }

    return route;
  }

  onRender() {
    // make menu visible
    this._parent.$el.fadeIn();

    // selected first active leaf-node
    const $active = this.$("li.leaf-node.selected").first();
    if ($active.length) {
      // grab leaf-node's href`
      const $link = $("a", $active);
      $link.length && document.location.assign($link.attr("href"));
    }
  }

  _handleRouteChange(model) {
    // select clickable nodes
    const $leaves = this.$("li.leaf-node");

    // find link by URL
    const url = hashFromRoute(model.getRoute());
    const $a = $leaves.find(`a[href="${url}"]`);
    if ($a.length) {
      // mark clickable nodes unselected
      $leaves.removeClass(SELECTED_NODE_CLASS_NAME);
      // mark parent LI as selected
      const $li = $a.parent();
      $li.addClass(SELECTED_NODE_CLASS_NAME);

      // open wrapping menu, if not already opened
      const $menu = $li.parents("li");
      if ($menu.length) {
        // is the menu already opened?
        const opened = $menu.hasClass("active");
        if (!opened) {
          // open it
          $menu.find("a").click();
        }
      }
    }
  }
}

export { View as default };
